import axios from 'axios';
import { authInterceptor, logout } from './auth-interceptor';

const kulaNexusService = import.meta.env.VITE_KULA_NEXUS_URL;

export const kulaNexusHttp = axios.create({
  baseURL: `${kulaNexusService}`,
  withCredentials: true,
});

kulaNexusHttp.interceptors.request.use((config) => {
  if (!kulaNexusService) {
    const controller = new AbortController();
    controller.abort();
    return { ...config, signal: controller.signal };
  }
  return config;
});

authInterceptor(kulaNexusHttp, {
  getAccessToken: () => {
    return localStorage.getItem('apiv1Auth');
  },

  shouldLogout: (error) => {
    const { response: { data = {} } = {} } = error;
    return ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some(
      (err) => data?.errors?.includes?.(err)
    );
  },

  shouldRefresh: (error) => {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return false;
    }
    const { response: { status, data = {} } = {} } = error;
    if (status === 401) return true;
    return data?.errors?.includes?.('err_token_expired');
  },

  logout: logout,
});
